export default "__VITE_ASSET__OXHjPtQm__"